































import Vue from 'vue';

export default Vue.extend({
  name: 'IntakeForm',
  data() {
    return {
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
      password: '',
      formClass: '',
      isEnteringPassword: false,
      isLoading: false,
    };
  },
  methods: {
    async onSubmit() {
      this.formClass = 'password';
      this.isEnteringPassword = true;
      this.isLoading = true;
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.isLoading = false;
    },
    async onContinue() {
      
    },
  },
  computed: {
    validData(): Boolean {
      return /^\S+@\S+$/.test(this.email);
    },
    validPassword(): Boolean {
      return /.{8,}/.test(this.password);
    },
  },
});
